import { render, staticRenderFns } from "./MonthlyStatement.vue?vue&type=template&id=1aa76b18&"
import script from "./MonthlyStatement.vue?vue&type=script&lang=js&"
export * from "./MonthlyStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports